module.exports = __webpack_public_path__ + "img/中国建设银行.63c6fb88.png";